import React, { useState } from 'react';

import { fadeInUpMotion } from 'utils/styles/animations';

import SideText from './SideText/SideText';

import * as S from './SidesText.styles';

export interface SidesTextProps {
  data: { label: string; description: string; align: 'left' | 'right' }[];
}

const defaultProps: Partial<SidesTextProps> = {
  data: [{ label: 'research', description: '-', align: 'right' }],
};

const SidesText: React.FC<SidesTextProps> = ({ data }) => {
  const [initialAnim, setInitialAnim] = useState(true);

  const animationTransition = initialAnim
    ? { delay: 1.4, duration: 0.6 }
    : { delay: 0, duration: 0 };

  return (
    <S.Wrapper role="list">
      {data.map((props, index) => (
        <S.SideTextContainer
          key={`${props.label}-${index}`}
          role="listitem"
          {...fadeInUpMotion}
          transition={animationTransition}
          onAnimationComplete={() => setInitialAnim(false)}
        >
          <SideText {...props} />
        </S.SideTextContainer>
      ))}
    </S.Wrapper>
  );
};

SidesText.defaultProps = defaultProps;

export default SidesText;
